// extracted by mini-css-extract-plugin
export default {"container":"csci7rlw7","designContainer":"cg5na8y9v","buttonContainer":"cxmcz6j5t"};